import { LogicTypes } from 'modules/shared/DataGrid';

export const GET_VISITORS_REQUEST = 'GET_VISITORS_REQUEST' as const;
export const GET_VISITOR_DELETE = 'GET_VISITOR_DELETE' as const;
export const GET_VISITORS_SUCCESS = 'GET_VISITORS_SUCCESS' as const;
export const GET_VISITORS_ERROR = 'GET_VISITORS_ERROR' as const;

export const GET_VISITOR_PHONES_REQUEST = 'GET_VISITOR_PHONES_REQUEST' as const;
export const GET_VISITOR_PHONES_SUCCESS = 'GET_VISITOR_PHONES_SUCCESS' as const;
export const GET_VISITOR_PHONES_ERROR = 'GET_VISITOR_PHONES_ERROR' as const;
export const GET_VISITOR_PHONE_ADD = 'GET_VISITOR_PHONE_ADD' as const;
export const GET_VISITOR_PHONE_DELETE = 'GET_VISITOR_PHONE_DELETE' as const;
export const GET_VISITOR_ADD_OR_UPDATE = 'GET_VISITOR_ADD_OR_UPDATE' as const;
export const GET_VISITOR_PHONE_LATEST = 'GET_VISITOR_PHONE_LATEST' as const;

export const fieldsNames = [
  'id',
  'arrivalDate',
  'driver',
  'driverPhone',
  'isFastLineDriver',
  'isFastLineForwarder',
  'forwarder',
  'forwarderPhone',
  'orders',
  'status',
];

export const defaultGridState = {
  sort: [],
  filter: {
    logic: LogicTypes.and,
    filters: [],
  },
  pagination: { skip: 0, pageSize: 15 },
};

export const defaultGridStatePage1000 = {
  sort: [],
  filter: {
    logic: LogicTypes.and,
    filters: [],
  },
  pagination: { skip: 0, pageSize: 15 },
};
